// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-container[data-v-647705fc]{padding-bottom:0;position:relative;height:calc(100vh - 40px)}.sidebar-container .cross[data-v-647705fc]{position:absolute;top:0;right:0;margin:1rem;font-size:2rem;background:none;border:none}.sidebar-container .content-container[data-v-647705fc]{min-height:100%;height:100%;padding-left:1.5rem;padding-right:1.5rem;padding-bottom:0}.sidebar-container .content-container .face[data-v-647705fc]{font-family:initial}", ""]);
// Exports
module.exports = exports;
